import { getRouteArea, isPlayerPage, MaintenanceNotice } from '@core/ui';
import { useLocation } from '@online-webinar/router';

// Mounted in the root route, outside the layouts, so it survives the `no-menu` body class that
// hides #account-bar on viewer pages. The player pages render the banner inside the viewer
// layout (shared with the embed widget); every other page — including the staff pages
// (broadcast, moderator, speaker, slide controller) and the on-demand catalogue — gets it from
// here, scope-filtered by area.
export const RootMaintenanceNotice = () => {
    const { pathname } = useLocation();
    if (isPlayerPage(pathname)) {
        return null;
    }
    return <MaintenanceNotice area={getRouteArea(pathname)} />;
};
